var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FetchContainer',{staticClass:"box h-full",attrs:{"entities":_vm.entities}},[_c('LatestYearBySource',{attrs:{"selectedYear":_vm.selectedYear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }